import { GET_CALL_SCHEDULE_TYPE_IDS, UPDATE_CALL_SCHEDULE_TYPE_FILTER, GET_CALL_SCHEDULE_TYPE_FILTER } from "../constants/action-types";

// INITIALIZE STATE
const initialState = {
  callScheduleTypeIds: {},
  callScheduleTypeFilter: {}
};

// REDUCER
export const CallScheduleReducer = (state = initialState, action) => {

  switch (action.type) {
    case GET_CALL_SCHEDULE_TYPE_IDS: {
      const incomingCallScheduleIds = action.payload;
      const callScheduleTypeIds = {};

      incomingCallScheduleIds.forEach(callScheduleId => {
        callScheduleTypeIds[callScheduleId.Code] = callScheduleId;
      });

      return {
        ...state,
        callScheduleTypeIds
      };
    }

    case GET_CALL_SCHEDULE_TYPE_FILTER: {
      var incomingCallScheduleTypeFilter = action.payload.CallScheduleTypeFilter;

      return {
        ...state,
        callScheduleTypeFilter: incomingCallScheduleTypeFilter
      };
    }

    case UPDATE_CALL_SCHEDULE_TYPE_FILTER: {
      const incomingCallScheduleTypeFilter = action.payload.callScheduleTypeFilter;

      return {
        ...state,
        callScheduleTypeFilter: incomingCallScheduleTypeFilter
      };
    }

    default:
      return state;
  }
};
